import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    devices: new Map<string, BluetoothDevice>(),
    characteristics: new Map<string, BluetoothRemoteGATTCharacteristic>(),
    exercise: 'Exercise 1',
    settings: {
      labeling: {
        soundFeedback: true,
        vibrationFeedback: true,
      },
      g_drive: {
        deleteAfterUpload: false,
      },
      input: {
        swipe: false,
      },
      exercises: [
        'Exercise 1', 'Exercise 2', 'Exercise 3', 'Exercise 4', 'Exercise 5',
      ],
      locations: [
        'Arm left', 'Arm right', 'Chest', 'Wrist left', 'Wrist right', 'Foot left', 'Foot right', 'Belly',
      ],
    },
  },
  mutations: {
    addDevice(state, data: { label: string, device: BluetoothDevice } ) {
      state.devices.set(data.label, data.device);
    },
    addCharacteristic(state, data: { label: string, characteristic: BluetoothRemoteGATTCharacteristic } ) {
      state.characteristics.set(data.label, data.characteristic);
    },
    loadSettings(state) {
      const data = localStorage.getItem('settings');
      if (data !== null) {
        state.settings = Object.assign({}, state.settings, JSON.parse(data));
      } else {
        localStorage.setItem('settings', JSON.stringify(state.settings));
      }
    },
    saveSettings(state) {
      localStorage.setItem('settings', JSON.stringify(state.settings));
    },
    setExercise(state, exercise: string) {
      state.exercise = exercise;
    },
  },
  actions: {
    // tslint:disable-next-line
    initialize({ dispatch }) {
      this.commit('loadSettings');
    },
    setExercise({ commit }, exercise: string) {
      commit('setExercise', exercise);
    },
  },
  getters: {
    devices: (state) => state.devices,
    characteristics: (state) => state.characteristics,
    settings: (state) => state.settings,
    exercise: (state) => state.exercise,
  },
});
